import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "./Common_recharge_page_banner.css";

function Common_recharge_page_banner({ title, breadcrumbItems = [], className = "" }) {
    return (
        <>
            <section className={`Common_recharge_page_banner ${className}`}>
                <div className="container">
                    <div className="Common_recharge_page_banner_container">
                        <div className="Common_recharge_page_banner_content">

                            {/* Dynamic Heading */}
                            <div className="banner_heading_holder">
                                <h6>{title}</h6>
                                <div className="line_holder"></div>
                            </div>


                        </div>
                            {/* Dynamic Breadcrumb */}
                            <Breadcrumb className="custom_breadcrumb">
                                {/* Always show Home */}
                                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                                    Home
                                </Breadcrumb.Item>

                                {breadcrumbItems.map((item, index) => (
                                    <Breadcrumb.Item
                                        key={index}
                                        linkAs={item.path ? Link : 'span'}
                                        linkProps={item.path ? { to: item.path } : {}}
                                        active={item.active}
                                    >
                                        {item.label}
                                    </Breadcrumb.Item>
                                ))}
                            </Breadcrumb>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Common_recharge_page_banner;
